import { formatDisplayValue } from "./simulatorUtils";

const ExternalValue = ({ field, value, onApply }) => {
  return (
    <div className=" d-flex align-items-center" style={{ gap: 5 }}>
      Valeur sur Hitech : {formatDisplayValue(field, value)}
      <button
        type="button"
        className="btn btn-sm btn-default"
        onClick={onApply}
      >
        Appliquer
      </button>
    </div>
  );
};

export default ExternalValue;
